import { render } from "./WalletList.vue?vue&type=template&id=33eb1e2b&scoped=true"
import script from "./WalletList.vue?vue&type=script&lang=js"
export * from "./WalletList.vue?vue&type=script&lang=js"

import "./WalletList.vue?vue&type=style&index=0&id=33eb1e2b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-33eb1e2b"

export default script